/*
 * Copyright (c) 2020. Sayari LLC
 */


import {Injectable} from '@angular/core';
import {Special} from '../shared/models/special.model';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';

const httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*', 'TimeZone': 'America/New_York'})
};

@Injectable()
export class SpecialsService {
    constructor(private http: HttpClient) {
    }

    getSpecials(page: number, latitude: number, longitude: number) {
        const searchArea = {'myLatitude': latitude, 'myLongitude': longitude, 'myRadius': 20};
        httpOptions.headers.set('TimeZone', 'America/New_York');
        return this.http.post<Special[]>(environment.apiUrl + '/v1/specials/vicinity/ALL/NONE/' + page, searchArea,
            httpOptions);
    }
}
